export default __webpack_public_path__ + "static/media/Music is Life.34254adf.png";